import React from 'react';
import styles from './StepLineBar.module.scss';

interface StepLineBarProps {
  currentStep: number;
  stepData: string[];
}

const StepLineBar: React.FC<StepLineBarProps> = ({ currentStep, stepData }) => {
  return (
    <div className={styles['step-line-bar']}>
      {stepData.map((text, idx) => {
        const isActive = idx + 1 === currentStep;
        const isCompleted = idx + 1 < currentStep;
        return (
          <React.Fragment key={idx}>
            <div className={styles['step-block']}>
              <div className={
                `${styles['circle']} ${isActive ? styles['active'] : ''} ${isCompleted ? styles['completed'] : ''}`
              }>
                {idx + 1}
              </div>
              <span className={styles['step-label']}>{text}</span>
            </div>
            {idx !== stepData.length - 1 && (
              <div className={
                `${styles['line']} ${isCompleted ? styles['completed'] : ''}`
              } />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepLineBar; 